import React from 'react';

import { StyledDivider } from './Divider.styles';

export const Divider = props => {
  return <StyledDivider {...props} />;
};
